// extracted by mini-css-extract-plugin
module.exports = {"link":"Endpoints-module--link--eEJF_"};